// extracted by mini-css-extract-plugin
export default {"date-holiday":"TimeLogsTable_date-holiday__8bboG","date-sunday":"TimeLogsTable_date-sunday__gBShD"};